import flagEn from "../../assets/images/lang_en.webp"
import flagCh from "../../assets/images/lang_ch.webp"
import flagRu from "../../assets/images/lang_ru.webp"

const languages = [
    { language: "en", imgPath: flagEn, title: "English" },
    { language: "cn", imgPath: flagCh, title: "简体中文" },
    { language: "ru", imgPath: flagRu, title: "Русский" },
]

export default languages